import swipeEvents from '../../domain/swipeEvents';

const filterTypes = {
    AllSwipeInOut: [
        swipeEvents.ACCESS_DENIED_SITE,
        swipeEvents.ACCESS_DENIED_SENTINEL,
        swipeEvents.VP_ACCESS_DENIED_SITE,
        swipeEvents.VP_ACCESS_DENIED_SENTINEL,
        swipeEvents.VISITOR_PASS_CANCELLED,

        swipeEvents.CARDLESS_SWIPE,
        swipeEvents.SELF_SWIPE_IN,
        swipeEvents.CARD_SWIPE,
        swipeEvents.VP_SWIPE,
        swipeEvents.RISK_ASSESSED_SWIPE_IN,

        swipeEvents.CARD_SWIPE_OUT,
        swipeEvents.SELF_SWIPE_OUT,
        swipeEvents.TEAM_SWIPE_OUT,
        swipeEvents.CARDLESS_SWIPE_OUT,
        swipeEvents.VP_SWIPE_OUT,
        swipeEvents.VP_TEAM_SWIPE_OUT
    ],
    SwipeIn: [
        swipeEvents.CARDLESS_SWIPE,
        swipeEvents.SELF_SWIPE_IN,
        swipeEvents.CARD_SWIPE,
        swipeEvents.VP_SWIPE,
        swipeEvents.RISK_ASSESSED_SWIPE_IN
    ],
    SwipeOut: [
        swipeEvents.CARD_SWIPE_OUT,
        swipeEvents.SELF_SWIPE_OUT,
        swipeEvents.TEAM_SWIPE_OUT,
        swipeEvents.CARDLESS_SWIPE_OUT,
        swipeEvents.VP_SWIPE_OUT,
        swipeEvents.VP_TEAM_SWIPE_OUT
    ],
    SpotChecks: [
        swipeEvents.CARDLESS_CHECK,
        swipeEvents.CARD_CHECK,
        swipeEvents.VP_CHECK,
        swipeEvents.SPOT_CHECK_DENIED,
    ],
    Competencies: [
        swipeEvents.AWARD_COMPETENCE,
        swipeEvents.CARDLESS_AWARD_COMPETENCE,
        swipeEvents.VP_AWARD_COMPETENCE,
        swipeEvents.VP_AWARD_COMPETENCE_DENIED,
        swipeEvents.AWARD_COMPETENCE_DENIED
    ]
};

export default filterTypes;